<template>
  <div>
    <div
      class="supply_demand_content"
      :style="{ backgroundImage: `url(${banner && banner.image})` }"
    >
      <div class="supply_demand_item warp">
        <ul class="supply_demand_item_left">
          <li v-for="(item, index) in industryList" :key="index">
            {{ item.name }}
            <ul class="item_list">
              <li
                v-for="(childs, index2) in industryList[index].children"
                :key="index2"
                @click="
                  goToUrl(`/classification_list?id=section1&categroyid=${childs.id}`)
                "
              >
                {{ childs.name }}
              </li>
            </ul>
          </li>
        </ul>
        <div
          class="supply_demand_item_right"
          :style="userinfo ? { height: '320px' } : { height: '338px' }"
        >
          <div class="btn_item" v-if="!userinfo">
            <span @click="goToUrl('/login')">登录</span>
            <span @click="goToUrl('/register')">注册</span>
          </div>
          <div class="add_fast" @click="goDemad()">快速发布需求</div>
          <p class="needs_newest_tips">最新需求</p>
          <ul class="needs_newest_list">
            <li
              @click="toDemandDetail(item)"
              v-for="(item, index) in demandList"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
          <p class="needs_newest_bater" @click="ToDeamad()">更多需求</p>
        </div>
      </div>
    </div>
    <div class="enterprise_list warp">
      <h3>名企榜</h3>
      <div class="swiper-list">
        <div class="button-prev" @click="swiperChange('prev')">
          <svg
            t="1603440419638"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2695"
            width="32"
            height="32"
          >
            <path
              d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
              p-id="2696"
              fill="#8a8a8a"
            ></path>
          </svg>
        </div>
        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <!-- <div
              class="swiper-slide box"
              v-for="(item, index) in companyList"
              :key="index"
              @click="toCompanyDetail(item)"
              :style="{ backgroundImage: `url(${item.headUrl})` }"
            ></div> -->
            <div
              class="swiper-slide box"
              v-for="(item, index) in companyList"
              :key="index"
            >
              <img :src="item.headUrl" alt="" @click="toCompanyDetail(item)" />
            </div>
          </div>
        </div>
        <div class="button-next" @click="swiperChange('next')">
          <svg
            t="1603440337801"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2017"
            width="32"
            height="32"
          >
            <path
              d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
              p-id="2018"
              fill="#8a8a8a"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--产品列表--->
    <div v-for="(item, index) in industryList" :key="index">
      <div class="equipment_list warp" :id="'page' + index">
        <!--头部分类 -->
        <equipmentNav
          @change="categoryChange($event, index)"
          :navObj="{ title: item.name, cateid: item.id, list: item.children }"
        ></equipmentNav>

        <div class="equipment_list_content">
            <!--二级分类内容-->
          <equipmentList
            class="equipment_list_content_left"
            v-if="productFlag && recomFlag"
            :productList="productList[index]"
            :recommendProductList="recommendProductList[index]"
          ></equipmentList>
           <!--侧边栏-->
          <newsRecommends class="equipment_list_content_right"    :title="item.name" :category="item.id"></newsRecommends>
        </div>
      </div>
      <div class="warp" v-if="advList.length > 0">
        <advertisement :list="advList.slice(2 * index, 2 * (index + 1))"></advertisement>
      </div>
    </div>
    <!--企业类型-->
    <div class="company_list warp">
      <ul class="company_nav">
        <li
          :class="current == index ? 'active' : ''"
          v-for="(item, index) in companyTypeList"
          :key="index"
          @click="companyTypeChange(item, index)"
          @mouseenter="mouseover(index, item)"
          @mouseleave="mouseLeave(item)"
        >
          {{ item.name }}
        </li>
        <span @click="onBater(10)">换一批</span>
      </ul>
      <ul class="company_content">
        <li v-for="(item, index) in cateCompanyList" :key="index">
          <div class="img">
            <img :src="item.headUrl" alt="" @click="onClick(item)" />
          </div>
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { systemList } from "@/api/company";
import { getRandomArray, routerGoNewpage } from "@/utils/index";
import equipmentList from "../../components/equipmentList";
import newsRecommends from "../../common/newsRecommends";
import advertisement from "../../components/advertisement";
import equipmentNav from "../../common/equipmentNav";
import {
  getCompanyList,
  getDemandList,
  getBanner,
  getAdv,
  getDictList,
  getCompanyByCate,
  getProduct,
} from "@/api/information";
import titleHeadVue from '../../common/titleHead.vue';
export default {
  components: { equipmentList, newsRecommends, advertisement, equipmentNav },
  data() {
    return {
      obj: {
        title: "行业资讯",
        content:
          "公司主营产品及服务包括：金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...",
      },
      swiperOption: {
        slidesPerView: 6,
        slidesPerGroup: 1,
      },
      newsRecommendObj: {
        title: "推荐资讯",
        text: "换一批",
        newData: [],
      },
      navObj: {
        title: "水处理设备",
        list: ["污水处理设备", "净水处理设备", "填料", "过滤/清洗设备"],
      },
      navObj1: {
        title: "气体设备",
        list: ["烟气处理设备", "废气处理设备", "风机/排风设备", "过滤/清洗设备"],
      },
      navObj2: {
        title: "药剂",
        list: ["水处理化学品", "空气处理化学品"],
      },
      navObj3: {
        title: "固废/环卫",
        list: ["固废处理设备", "危废", "环卫清洁设备"],
      },
      companyList: [],
      demandPager: {
        curPage: 1,
        limit: 3,
      },
      demandList: [],
      navType: "5",
      banner: "",
      advType: 7,
      advList: [],
      companyTypeList: [],
      currentCompanyType: 29,
      cateCompanyList: [],
      listChildren: [],
      systemList: [], //一级
      dataList: [], //二级
      threeList: [], //三级
      industryList: [],
      list: [],
      current: 0,

      recommendProductList: [],
      productList: [],
      productFlag: false,
      recomFlag: false,
      total:0,
      comanyQuery:{
        curPage:1,
        limit:10
      }
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.user.userInfo;
    },
  },
  created() {
    this.getCompanyList();
    this.getDemandList();
    this.getBanner();
    this.getAdv();
    this.getCompanyType();
    this.getsystemList();
    this.companyFilter();
  },

  methods: {
    onClick(item) {
      sessionStorage.setItem("corporateId", item.userId);
      this.$store.dispatch("company/getBaseInfo");
      routerGoNewpage("/corporate_detail", { id: item.userId });
    },
    companyTypeChange(item, index) {
      this.current = index;
      this.currentCompanyType = item.id;
      this.companyFilter();
    },
    //移入移出
    mouseover(index, data) {
      this.$nextTick(() => {
        this.current = index;
        this.currentCompanyType = data.id;
        this.companyFilter();
        this.$set(data, "show", true);
      });
    },
    mouseLeave(data) {
      this.$set(data, "show", false);
    },
    //企业类型换一批
    onBater(length) {
      this.cateCompanyList = _.compact(
        getRandomArray(_.cloneDeep(this.cateCompanyList), length)
      );
    },
    //查询供需三级分类
    getsystemList() {
      systemList()
        .then((res) => {
          if(res.code == 0){
            this.industryList = res.data;
            this.industryList.map((item, index) => {
              this.getProduct(item.children[0].id, index);
              this.getRecommendProduct(item.children[0].id, index);
            });
          }
        })
        .catch((err) => {});
    },
    //查询企业类型
    getCompanyType() {
      getDictList({
        code: "company_type",
      }).then((res) => {
        if(res.code == 0){
          this.companyTypeList = res.data[0].children;
        }
      });
    },
    //获取企业列表
    companyFilter() {
      getCompanyByCate({
        company_type: this.currentCompanyType,
        curPage: 1,
        limit: 10,
      }).then((res) => {
         if(res.code == 0){
          this.cateCompanyList = res.page.list;
         }
      });
    },
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 20,
        type: this.advType,
      }).then((res) => {
        if(res.code == 0){
          this.advList = res.page.list;
        }
      });
    },
    getBanner() {
      getBanner({
        type: this.navType,
      }).then((res) => {
        if(res.code == 0){
          this.banner = res.page.list[0];
        }
      });
    },
    toDemandDetail(item) {
      this.$router.push({
        path: "/demand_detail",
        query: { id: item.id },
      });
    },
    //获取需求列表
    getDemandList() {
      getDemandList({
        ...this.demandPager,
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
          this.demandList = res.data.list;
          this.getMate(this.demandList);
        }
      });
    },
    categoryChange(category, index) {
      this.getProduct(category, index);
      this.getRecommendProduct(category, index);
    },
    //获取企业列表
    getCompanyList() {
      getCompanyList({
        ...this.comanyQuery,
        weight: 0
      }).then((res) => {
        if(res.code == 0){
         this.total = res.data.totalCount;
         this.companyList = this.companyList.concat(res.data.list);
        }
      });
    },
    toCompanyDetail(item) {
      sessionStorage.setItem("corporateId", item.userId);
      this.$store.dispatch("company/getBaseInfo");
      routerGoNewpage("/corporate_detail", { id: item.userId });
    },
    goToUrl(url) {
      this.$router.push(url);
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    //快速发布需求
    goDemad() {
      let type = this.$store.state.user.userInfo;
      if (type != null) {
        this.$router.push("demandAdd");
      } else {
        this.$router.push("/login");
      }
    },
    //更多需求
    ToDeamad() {
      routerGoNewpage("/summary_demand", {});
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
             this.comanyQuery.curPage ++ ;
             if(this.total == this.companyList.length) return;
             this.getCompanyList();
          }
          break;
      }
    },
    goToUrl(url) {
      this.$router.push(url);
    },
    //模拟锚点跳转
    goAnchor(selector) {
      let anchor = document.getElementById(selector);
      //document.documentElement.scrollTop = anchor.offsetTop;
      let total = anchor.offsetTop;

      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      // 获取当前滚动条与窗体顶部的距离
      let distance = document.documentElement.scrollTop || document.body.scrollTop;
      // 计算每一小段的距离
      let step = total / 50;
      (function smoothDown() {
        if (distance < total) {
          distance += step; // 移动一小段
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance; // 设定每一次跳动的时间间隔为10ms
          setTimeout(smoothDown, 10);
        } else {
          // 限制滚动停止时的距离
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      })();
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keyword";
      metas[0].content = data[0].seokeywords;
      metas[1].name = "description";
      metas[1].content = data[0].seodescription;
      document.getElementsByTagName("title")[0].innerText =
        this.$route.meta.title + "_智污邦环保服务平台";
      // document.getElementsByTagName("title")[0].innerText= data[0].title +'_智污邦环保服务平台';
    },

    //获取推荐产品
    getRecommendProduct(categoryId, i) {
      getProduct({
        curPage: 1,
        limit: 4,
        recommend: 1,
        categoryId,
      }).then((res) => {
        if(res.code == 0){
          this.recommendProductList[i] = res.page.list;
          this.$forceUpdate(this.recommendProductList[i] = res.page.list);
          if (i == this.industryList.length - 1) {
            this.recomFlag = true;
          }
        }
      });
    },
    //获取产品
    getProduct(categoryId, i) {
      getProduct({
        curPage: 1,
        limit: 8,
        categoryId,
      }).then((res) => {
        if (res.code == 0) {
          this.productList[i] = res.page.list;
          this.recommendProductList[i] = res.page.list;
          this.$forceUpdate();
          if (i == this.industryList.length - 1) {
            this.productFlag = true;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
div {
  .supply_demand_content {
    width: 100%;
    height: 399px;
    background-size: cover;
    background-position: center;
    .supply_demand_item {
      display: flex;
      justify-content: space-between;
      .supply_demand_item_left {
        height: 399px;
        width: 20%;
        background: rgba(12, 47, 126, 0.5);
        > li {
          position: relative;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          height: 16.6%;
          line-height: 4;
          padding-left: 40px;
          cursor: pointer;
          transition: 0.5s;
          > ul {
            display: none;
            z-index: 100;
          }
          &:hover {
            background: rgba(103, 189, 48, 1);
            > ul {
              width: 216px;
              position: absolute;
              right: -216px;
              background: rgba(12, 47, 126, 0.5);
              display: block;
              top: 0;
              li {
                height: 50px;
                line-height: 50px;
                padding-left: 40px;
                &:hover {
                  background: rgba(103, 189, 48, 1);
                }
              }
            }
          }
          &::before {
            position: absolute;
            top: 25px;
            left: 15px;
            display: inline-block;
            content: "";
            width: 15px;
            height: 17px;
          }
          &:nth-of-type(1) {
            &::before {
              background: url("../../assets/images/supply_demand_1.png") no-repeat
                center/100%;
            }
          }
          &:nth-of-type(2) {
            &::before {
              background: url("../../assets/images/supply_demand_2.png") no-repeat
                center/100%;
            }
          }
          &:nth-of-type(3) {
            &::before {
              background: url("../../assets/images/supply_demand_3.png") no-repeat
                center/100%;
            }
          }
          &:nth-of-type(4) {
            &::before {
              background: url("../../assets/images/supply_demand_4.png") no-repeat
                center/100%;
            }
          }
          &:nth-of-type(5) {
            &::before {
              background: url("../../assets/images/supply_demand_5.png") no-repeat
                center/100%;
            }
          }
          &:nth-of-type(6) {
            &::before {
              background: url("../../assets/images/supply_demand_6.png") no-repeat
                center/100%;
            }
          }
        }
        .active {
          background: rgba(103, 189, 48, 1);
        }
      }
      .supply_demand_item_right {
        width: 35%;

        padding: 30px 20px;
        margin: auto 0;
        background: rgba(13, 45, 118, 0.5);
        .btn_item {
          display: flex;
          justify-content: space-between;
          span {
            cursor: pointer;
            width: 50%;
            text-align: center;
            padding: 10px 0;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            &:nth-of-type(1) {
              margin-right: 20px;
              background: linear-gradient(
                104deg,
                rgba(160, 228, 83, 1),
                rgba(71, 172, 34, 1)
              );
            }
            &:nth-of-type(2) {
              background: linear-gradient(
                104deg,
                rgba(255, 213, 0, 1),
                rgba(244, 116, 39, 1)
              );
            }
          }
        }
        .add_fast {
          cursor: pointer;
          padding: 10px 65px;
          text-align: center;
          margin: 10px 0 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          border: 1px solid #eeeeee;
        }
        .needs_newest_tips {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
        .needs_newest_tips:hover {
          color: #ff8a02;
          cursor: pointer;
        }
        .needs_newest_list {
          padding: 10px 0;

          li {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
            padding-top: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            border-top: 1px dashed #ffffff;
            cursor: pointer;

            &:last-of-type {
              margin-bottom: 0;
            }
            &:hover {
              color: #ff8a02;
            }
          }
        }
      }
    }
  }
  .enterprise_list {
    h3 {
      margin-top: 30px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      position: relative;
      margin-left: 15px;
      margin-bottom: 15px;
      &::before {
        display: inline-block;
        content: "";
        width: 5px;
        height: 23px;
        background: #ff7302;
        position: absolute;
        left: -15px;
        bottom: 4px;
      }
    }
    .swiper-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .button-prev,
      .button-next {
        cursor: pointer;
        // position: absolute;
        // top: 25%;
        z-index: 999;
      }
      .button-next {
        // right: 0;
      }
      .swiper-container {
        width: 100%;
        .box {
          text-align: center;
          min-width: 169px;
          height: 97px;
          // border: 1px solid #EBEBEB;
          background-position: center;
          background-size: cover;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #ebebeb;
          img {
            height: 69px;
            width: 69px;
            border-radius: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
  .equipment_list {
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .equipment_list_content {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  .equipment_list_content_left{
    width: 77%;
  }
  .equipment_list_content_right{
    width: 22%;

  }
  .company_list {
    margin-top: 50px;
    .company_nav {
      display: flex;
      margin-bottom: 15px;
      position: relative;
      li {
        margin-right: 20px;
        &:last-of-type {
          margin-right: 0;
        }
        cursor: pointer;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      span {
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 14px;
        &::before {
          display: inline-block;
          content: "";
          width: 17px;
          height: 17px;
          background: url("../../assets/images/break.png") no-repeat center/100%;
          vertical-align: bottom;
          margin-right: 3px;
        }
      }
      .active {
        position: relative;
        &:after {
          position: absolute;
          left: 0;
          bottom: -5px;
          display: inline-block;
          content: "";
          width: 100%;
          height: 2px;
          background: rgba(255, 115, 2, 1);
        }
      }
    }
  }
  .company_content {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    justify-content: flex-start;
    margin-bottom: 20px;
    li {
      cursor: pointer;
      text-align: center;
      // width: 19%;
      width: 18.6%;
      margin-bottom: 20px;
      margin-right: 15px;
      .img {
        width: 100%;
        height: 130px;
        border: 1px solid #ddd;
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        &:hover {
          transform: scale(1.2);
        }
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.needs_newest_bater {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-top: 7px;
}
.needs_newest_bater:hover {
  cursor: pointer;
  color: #ff8a02;
}
</style>



// WEBPACK FOOTER //
// src/view/supply_demand/supply_demand.vue